// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";

import { IState } from "states/states";
import { IAction } from "actions";
import { ICondition } from "parameter";
import { round } from "utils";

interface IConditionExtProps {
  index: number;
}

interface IConditionProps {
  parameter: ICondition;
  value: number | undefined;
}

const mapStateToProps = (state: IState, ownProps: IConditionExtProps) => {
  const props: IConditionProps = {
    parameter: state.parameter!.condition[ownProps.index],
    value: state.data.condition[ownProps.index],
  };
  return props;
};

interface IConditionDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IConditionDispatch = {};
  return dispatchProps;
};

class ConditionComponent extends React.Component<
  IConditionExtProps & IConditionProps & IConditionDispatch
> {
  public render() {
    return (
      <tr className="conditionitem">
        <td>{this.props.parameter.name}</td>
        <td className="value-col right">{round(this.props.value, 6)}</td>
      </tr>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConditionComponent);
